import React from "react";
export function ViewsRenderer(props) {
    const { viewsData, views } = props;
    const createEvent = props.createEvent || (() => { });
    const renderView = (view) => {
        const ComponentToRender = views[view.name];
        const props = { key: view.uid };
        view.props.forEach((prop) => {
            if (prop.type === "data") {
                props[prop.name] = prop.data;
            }
            else if (prop.type === "event") {
                props[prop.name] = (...args) => {
                    return createEvent(prop.uid, ...args);
                };
            }
        });
        const children = viewsData
            .filter((runningView) => runningView.parentUid === view.uid)
            .sort((a, b) => a.childIndex - b.childIndex)
            .map((runningView) => renderView(runningView));
        return React.createElement(ComponentToRender, { ...props }, children);
    };
    const roots = viewsData.filter((view) => view.isRoot);
    if (roots.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(React.Fragment, null, roots.map(renderView));
}
//# sourceMappingURL=ViewsRenderer.js.map